import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    if (!value) {
      return '';
    }

    const sanitizedScriptTags = value.replace(/<script.*?>.*?<\/script>/gis, '');

    return this.sanitizer.bypassSecurityTrustHtml(sanitizedScriptTags);
  }
}
